import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import { useT } from "@/i18n";

const STORAGE_KEY = "geolyshop.cookie_consent";

export default function CookieConsent() {
  const t = useT();
  const [legal, setLegal] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    api.get("/public/legal").then(({ data }) => {
      setLegal(data || {});
      if ((data || {}).cookie_banner_enabled) setVisible(true);
    }).catch(() => {});
  }, []);

  const decide = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;
  const message = legal?.cookie_banner_text?.trim() || t("cookie.defaultText");

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 40 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6"
        data-testid="cookie-consent"
      >
        <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-xl border border-border bg-card/95 p-5 shadow-2xl shadow-black/20 backdrop-blur-md sm:flex-row sm:items-center">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand">
            <Cookie className="h-5 w-5" />
          </span>
          <div className="min-w-0 flex-1 text-sm text-muted-foreground">
            {message}{" "}
            <Link to="/cookie" data-testid="cookie-learn-more" className="font-medium text-brand hover:underline">
              {t("cookie.learnMore")}
            </Link>
          </div>
          <div className="flex shrink-0 gap-2">
            <button onClick={() => decide("rejected")} data-testid="cookie-reject"
              className="rounded-md border border-border px-4 py-2 text-sm font-medium transition-colors hover:bg-secondary">
              {t("cookie.reject")}
            </button>
            <button onClick={() => decide("accepted")} data-testid="cookie-accept"
              className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-transform hover:opacity-90 active:scale-95">
              {t("cookie.accept")}
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
